import { render, staticRenderFns } from "./AppNavigationComponent.vue?vue&type=template&id=03f0b8bf&"
import script from "./AppNavigationComponent.vue?vue&type=script&lang=js&"
export * from "./AppNavigationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports